<template>
  <div></div>
</template>

<script>
export default {
  name: "TopNavbar",
};
</script>